<template>
    <div>
      <v-dialog v-model="userDetailModal" persistent max-width="600" >
      <v-card>
        <v-card-title class="headline indigo lighten-2">
          <div class="text-center white--text" style="width: 100%">
            {{ $t("title.details") }}
          </div>
        </v-card-title>
        <v-card-subtitle class="subtitle-1 mt-2 font-weight-bold">
          {{ $t("labels.personalDetails") }}
    </v-card-subtitle>
        <v-card-text>
            
         <strong>Isim :</strong>  {{ detailUser.Name }}
        </v-card-text>
        <v-card-text>
            <strong>Telefon Numarası :</strong>{{ detailUser.Phone }}
        </v-card-text>

        <v-card-subtitle v-if="detailUser.Notes!=null" class="subtitle-1 mt-2 font-weight-bold">
          {{ $t("labels.userNote") }}
    </v-card-subtitle>
        <v-card-text v-if="this.detailUser.Notes!=null">
          {{ detailUser.Notes }}
        </v-card-text>
        <v-card-subtitle v-if="this.detailUser.FileUrl!=null" class="subtitle-1 mt-2 font-weight-bold">
          {{ $t("labels.audioRecordings") }}
    </v-card-subtitle>
        <div  class="ml-5 mr-5" v-for="(url, index) in this.detailUser.FileUrl" :key="index">
      <audio controls style="width:-webkit-fill-available"  preload="auto">
        <source :src="url" type="audio/mpeg">
      </audio>
    </div>
    <v-card-subtitle class="subtitle-1 mt-2 font-weight-bold">
              <a :href="this.detailUser.MapLink" target="_blank"
                >Konum Bilgisi Göster</a
              >
            </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn
            color="grey" 
            outlined 
            large
            @click="userDetailModal = false"
          >
            {{ $t("buttons.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <!-- Page content -->
      <v-card style="border-radius: 10px">
        <v-card-title style="color: #595959">
          <v-row>
            <v-col class="py-2">{{ $t("title.helpRequests") }}</v-col>
            <v-spacer />
            
          </v-row>
        </v-card-title>
        
        <v-divider />
  
        <v-card-text class="pt-4"
          ><v-row justify="space-between">
           
            <v-col cols="2">
              <v-select
                v-model="itemsPerPage"
                :items="perPageValues"
                :label="$t('labels.selectItemsPerPage')"
                item-value="value"
                item-text="name"
                @change="changeItemsPerPage()"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loadings.table"
            :options.sync="options"
            :hide-default-footer="true"
            :footer-props="{
              disablePagination: true,
              disableItemsPerPage: true,
            }"
            :no-data-text="$t('description.noList')"
          >
            <!-- eslint-disable -->
            
          <template v-slot:item.EventDate="{ item }">
            {{ convertToLocal(item.EventDate) }}
          </template>
            <template v-slot:item.SafetyStatus="{ item }">
              <v-chip
                v-if="item.SafetyStatus == 0"
                class="ma-2"
                small
                color="green"
                text-color="white"
              >
               {{ $t("labels.successEmergency") }}
              </v-chip>
              <v-chip
                v-if="item.SafetyStatus == 1"
                class="ma-2"
                small
                color="red"
                text-color="white"
              >
              {{ $t("labels.alertEmergency") }}
              </v-chip>
              <v-chip
                v-if="item.SafetyStatus == 2"
                class="ma-2"
                small
                color="orange"
                text-color="white"
              >
              {{$t('labels.needy')}}
              </v-chip>
              
            </template>
  
            <template v-slot:item.actions="{ item }">
              
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="openDetailPopup(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>{{ $t("labels.tooltipDetail") }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2 md4 lg4">
            <v-pagination
              @input="paginationChangeHandler"
              :value="pagination.page"
              :length="pages"
              :total-visible="10"
              circle
            ></v-pagination>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  import EmergencyServices from "../services/EmergencyServices";
  import { mapActions } from "vuex";
  export default {
    data: () => ({
      userDetailModal:false,
      detailUser:{},
      // List options
      options: {
        itemsPerPage: 15,
      },
      top: 15,
      skip: 0,
      tableData: [],
      
      headers: [],
      //Loading states
      loadings: {
        table: false,
        select: false,
        send: false,
      },
      //Group
  
      //Pagination models
      pagination: {},
      itemsPerPage: 15,
      perPageValues: [10, 15, 30, 50, 100],
     

  
    }),
  
    watch: {},
    mounted() {
      this.setup();
      this.getTableList();
    },
    components: {
    },
  
    computed: {
      totalRecords() {
        return this.items.length;
      },
      pageCount() {
        return this.totalRecords / this.itemsPerPage;
      },
      pages() {
        if (
          this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) {
          return 0;
        }
  
        return Math.ceil(
          this.pagination.totalItems / this.pagination.rowsPerPage
        );
      },
    },
  
    methods: {
      setup() {
        this.headers = [
          {
            text: "Acil Durum",
            value: "EventName",
            sortable: false,
            align: "center",
          },
          {
            text: "Kullanıcı",
            value: "Name",
            sortable: false,
          },
          {
            text: "Acil Durum Tarihi",
            value: "EventDate",
            sortable: false,
            align: "center",
          },
          {
            text: "Güvenlik Durumu",
            value: "SafetyStatus",
            sortable: false,
            align: "center",
          },
          {
            text: this.$t("title.tableHeaderActions"),
            value: "actions",
            sortable: false,
            align: "center",
          },
          (this.pagination = {
            totalItems: 200,
            rowsPerPage: this.itemsPerPage,
            page: 1,
          }),
        ];
      },
      //Fill's the emergency list
      getTableList() {
        this.$store.state.loadingStatus = true;
        EmergencyServices.getUsersForRescueTeam(
          this.pagination.page,
        this.pagination.rowsPerPage,
        )
          .then((res) => {
            this.tableData = res.data.Result;
            this.pagination.totalItems = res.data.TotalItems;
          })
          .catch((err) => {
            window.handleServiceError(res, err);
          })
          .then(() => {
            this.$store.state.loadingStatus = false;
          });
      },
  
      openDetailPopup(item){
this.detailUser=item;
this.userDetailModal=true;
      },
      //Change displayed items per page, page number one is default
      changeItemsPerPage() {
        this.pagination.rowsPerPage = this.itemsPerPage;
        this.pagination.page = 1;
        this.options.itemsPerPage = this.itemsPerPage;
        this.getTableList();
      },
  
      //Change list pagination page
      paginationChangeHandler(pageNumber) {
        this.pagination.page = pageNumber;
        this.getTableList();
      },
    },
  };
  </script>
  